/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { DocumentTypeEntity } from '../../distribution/models';
import { UserService } from 'src/app/user/services';
import { Format } from '../../developer/models/format';
import { Variant } from 'src/app/developer/models/variant';
import { VariantVersion } from 'src/app/developer/models/variant-version';
import { InitStep } from 'src/app/distribution/models/init-step';
import { AssemblyArtifact } from 'src/app/developer/models/artifact';
import { FormatType } from 'src/app/developer/models/format-type';
import { DocumentTypeClassifierResolverEntity } from 'src/app/developer/models/document-type-classifier-resolver';
import { ConfigurationKeyUsage } from 'src/app/developer/models/configuration-key-usage';
import { DocumentTypeDeveloper } from 'src/app/developer/models/document-type';

@Injectable({
  providedIn: 'root'
})
export class BizGridFiltervalues {

  constructor(private userService: UserService) { }

  getDocumentTypeFilterData(documentTypeIds: number[], distros: DocumentTypeEntity[]) {
    if (documentTypeIds === null || documentTypeIds === undefined || documentTypeIds.length === 0) { return []; }
    if (distros === null || distros === undefined || distros.length === 0) { return []; }
    const documentTypeMap = new Map(distros.map(dt => [dt.Id, dt.Name]));
    return documentTypeIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = documentTypeMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  getDocumentTypeDeveloperFilterData(documentTypeIds: number[], distros: DocumentTypeDeveloper[]) {
    if (documentTypeIds === null || documentTypeIds === undefined || documentTypeIds.length === 0) { return []; }
    if (distros === null || distros === undefined || distros.length === 0) { return []; }
    const documentTypeMap = new Map(distros.map(dt => [dt.Id, dt.Name]));
    return documentTypeIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = documentTypeMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  getFormatFilterData(formatIds: number[], formats: Format[]) {
    if (formatIds === null || formatIds === undefined || formatIds.length === 0) { return []; }
    if (formats === null || formats === undefined || formats.length === 0) { return []; }
    const formatMap = new Map(formats.map(f => [f.FormatsId, f.FormatName]));
    return formatIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = formatMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  getFormatTypeFilterData(formatTypeIds: number[], formatTypes: FormatType[]) {
    if (formatTypeIds === null || formatTypeIds === undefined || formatTypeIds.length === 0) { return []; }
    if (formatTypes === null || formatTypes === undefined || formatTypes.length === 0) { return []; }
    const formatMap = new Map(formatTypes.map(f => [f.Id, f.Name]));
    return formatTypeIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = formatMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  getDocumentTypeClassifierResolverFilterData(documentTypeClassifierResolverIds: number[], documentTypeClassifierResolvers: DocumentTypeClassifierResolverEntity[]) {
    if (documentTypeClassifierResolverIds === null || documentTypeClassifierResolverIds === undefined || documentTypeClassifierResolverIds.length === 0) { return []; }
    if (documentTypeClassifierResolvers === null || documentTypeClassifierResolvers === undefined || documentTypeClassifierResolvers.length === 0) { return []; }
    const formatMap = new Map(documentTypeClassifierResolvers.map(f => [f.Id, f.Name]));
    return documentTypeClassifierResolverIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = formatMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  geConfigurationKeyUsageFilterData(configKeyUsageIds: number[], configKeyUsages: ConfigurationKeyUsage[]) {
    if (configKeyUsageIds === null || configKeyUsageIds === undefined || configKeyUsageIds.length === 0) { return []; }
    if (configKeyUsages === null || configKeyUsages === undefined || configKeyUsages.length === 0) { return []; }
    const formatMap = new Map(configKeyUsages.map(f => [f.KeyUsageId, f.KeyUsageName]));
    return configKeyUsageIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = formatMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  getVariantFilterData(variantIds: number[], variants: Variant[]) {
    if (variantIds === null || variantIds === undefined || variantIds.length === 0) { return []; }
    if (variants === null || variants === undefined || variants.length === 0) { return []; }
    const variantMap = new Map(variants.map(f => [f.VariantsId, f.VariantName]));
    return variantIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = variantMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  getVersionFilterData(versionIds: number[], versions: VariantVersion[]) {
    if (versionIds === null || versionIds === undefined || versionIds.length === 0) { return []; }
    if (versions === null || versions === undefined || versions.length === 0) { return []; }
    const variantMap = new Map(versions.map(f => [f.VariantVersionsId, f.VariantVersionName]));
    return versionIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = variantMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  getInitStepFilterData(initStepIds: number[], initSteps: InitStep[]) {
    if (initStepIds === null || initStepIds === undefined || initStepIds.length === 0) { return []; }
    if (initSteps === null || initSteps === undefined || initSteps.length === 0) { return []; }
    const initStepMap = new Map(initSteps.map(f => [f.Id, f.Name]));
    return initStepIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = initStepMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }

  getAssemblyArtifactFilterData(artifactIds: string[], artifacts: AssemblyArtifact[]) {
    if (artifactIds === null || artifactIds === undefined || artifactIds.length === 0) { return []; }
    if (artifacts === null || artifacts === undefined || artifacts.length === 0) { return []; }
    const initStepMap = new Map(artifacts.map(f => [f.ArtifactId, f.Name]));
    return artifactIds
      .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
      .map(id => {
        let name = initStepMap.get(id);
        if (name === undefined || name === '') {
          name = '(Blanks)';
        }
        return { id, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort the names alphabetically
      .map(item => ({
        text: item.name,
        value: item.id
      }));
  }


  getUserFilterData(userIds: number[]){
    return userIds
        .filter((val, idx, self) => self.indexOf(val) === idx) // Filter out duplicates
        .map(id => {
          let name = this.userService.getSimpleUser(id)?.DisplayName ?? `${id}`;
          if (name === undefined || name === '' || name === 'null') {
              name = '(Blanks)';
          }
          return { id, name };
      })
        .sort((a, b) => a?.name?.localeCompare(b?.name)) // Sort the names alphabetically
        .map(item => ({
            text: item.name,
            value: item.id
        }));
  }

    getPropertyValues<T>(list: T[], propertyName: keyof T): any[] {
        return list?.map(item => item[propertyName]) ?? [];
    }
}
